module.exports = __webpack_public_path__ + "img/DS6206X9.428e81ae.jpg";